/**
 * Scenario Modeling Type Definitions
 *
 * Types for strategic staffing planning and FTE calculations
 */

/**
 * Input parameters for scenario modeling
 */
export type ScenarioInputs = {
  targetUtilization: number; // 0.0 - 1.0 (e.g., 0.8 = 80%)
  monthlyPatientVolume: number; // Expected number of patients per month
  visitsPerPatient: { [role: string]: number }; // Average visits per patient by role
  growthRatePercent: number; // Expected growth rate (e.g., 5 = 5% growth)
  planningMonths: number; // Number of months to project (default 12)
};

/**
 * Output results from scenario modeling
 */
export type ScenarioResults = {
  requiredFTE: { [role: string]: number }; // Required FTE by role
  currentFTE: { [role: string]: number }; // Current FTE by role
  delta: { [role: string]: number }; // Difference (required - current)
  projectedMonthly: MonthlyProjection[]; // Month-by-month projection
};

/**
 * Monthly projection data
 */
export type MonthlyProjection = {
  month: number; // Month number (0-11 for 12 months)
  monthLabel: string; // Human-readable month label
  patientVolume: number; // Expected patient volume
  requiredFTE: { [role: string]: number }; // Required FTE by role
};

/**
 * Constants for FTE calculations
 */
export const FTE_CONSTANTS = {
  HOURS_PER_WEEK: 40,
  WEEKS_PER_MONTH: 4.33, // Average weeks per month
  MINUTES_PER_MONTH: 40 * 60 * 4.33, // ~10,400 minutes per FTE per month
};
